import React, { useState, useEffect, useRef, memo, useCallback } from 'react';

import './styles.scss';

import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';

import { IAutoComplete } from './interface';
import { Button } from 'components/Button';

const AutoComplete: React.FC<IAutoComplete> = ({
  children,
  show,
  request,
  onSelect,
  content,
  maxResults,
  minLengthSearch,
  hide
}) => {
  const [data, setData] = useState<Array<any | undefined>>();
  const requestRef = useRef<any>();

  const minLength = minLengthSearch || 3;

  function returnData(item: any) {
    onSelect(item);
  }

  function autoComplete(value: string) {
    setData(undefined);
    if (requestRef.current) clearTimeout(requestRef.current);
    if (!value || value.length < minLength) return;

    requestRef.current = setTimeout(async () => {
      try {
        const response = await request(value);
        setData(response.data.slice(0, maxResults || 10));
      } catch (error) {
        return setData([]);
      }
    }, 1000);
  }

  useEffect(() => {
    autoComplete(children.props.value);
  }, [children.props.value]);

  const textSearchAutocomplete = useCallback((length: number) => {
    let msg = '';
    if (data?.length === 0) {
      msg = 'Nenhum dado encontrado.';
    } else if (length < minLength) {
      msg = 'Continue digitando...';
    } else msg = 'Carregando...';

    return msg;
  }, [data]);

  return (
    <Column className="relative flex-1">
      {children}
      {show && children.props.value && (
        <Column
          className={`bg-white w-100 py-1 z-2 ${!hide ? 'absolute' : ''}`}
          style={{
            top: 43,
            borderRadius: '0px 0px 10px 10px',
            border: 'solid 1px #ccc5',
            width: 'auto',
            maxHeight: '400px',
            overflowY: 'auto',
          }}
        >
          {data && data.length > 0 ? (
            data.map((item: any, index: any) => (
              <Button
                id='auto-complete-header'
                onClick={() => returnData(item)}
                className="w-100 autocomplete"
                key={index}
                width="auto"
              >
                <Column
                  className="w-100"
                  style={{ borderBottom: '1px solid #eee' }}
                >
                  {content({ item })}
                </Column>
              </Button>
            ))
          ) : (
            <Text
              className="text-left color-blue-gray px-2 p-2 w-100"
              size={13}
            >
              {textSearchAutocomplete(children.props.value.length)}
            </Text>
          )}
        </Column>
      )}
    </Column>
  );
};

export default memo(AutoComplete);
